<template lang="pug">
  .b2b-table-centres
    //- Filtros Tabla Empresas de un servicio
    b2b-filters-centres(:filter-options='options')

    ods-table(
      :data='centres.tableData',
      :default-sort="{prop: 'partyName', order: 'ascending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='mini',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='description',
        :label='$t("centres.entity_table.name")',
        :show-overflow-tooltip='true',
        v-if='isShowNameCentre',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("centres.entity_table.dateCreationTime")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeCentre',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='centreCode',
        :label='$t("centres.entity_table.code")',
        :show-overflow-tooltip='true',
        v-if='isShowCodeCentre',
        sortable='')
      ods-table-column(
        prop='gln',
        :label='$t("centres.entity_table.gln")',
        :show-overflow-tooltip='true',
        v-if='isShowGlnCentre',
        sortable='')
      ods-table-column(
        prop='town',
        :label='$t("centres.entity_table.town")',
        :show-overflow-tooltip='true',
        v-if='isShowTownCentre',
        sortable='')
      ods-table-column(
        prop='province',
        :label='$t("centres.entity_table.province")',
        :show-overflow-tooltip='true',
        v-if='isShowProvinceCentre',
        sortable='')
      ods-table-column(
        prop='country',
        :label='$t("centres.entity_table.country")',
        :show-overflow-tooltip='true',
        v-if='isShowCountryCentre',
        :formatter='formatterCountry',
        sortable='')
      ods-table-column(
        prop='enable',
        :label='$t("parties.entity_table.enable")',
        sortable='')
        template(slot-scope='scope')
          ods-switch(
            v-model='scope.row.enable',
            :disabled='!(canAdminProject && partySponsor)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateCentreStatus(scope.row)')
      ods-table-column(
        prop='permanentEstablishment',
        width='220'
        :label='$t("parties.entity_table.permanentEstablishment")',
        v-if='canAdminIndra'
        sortable='')
        template(slot-scope='scope')
          ods-switch(
            v-model='scope.row.permanentEstablishment',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateCentrePermanentEstablishment(scope.row)')

      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-tooltip(placement='left'
            v-if='canAdminApprovalFlowByLevels && projectWithApprovalFlowConfiguration && partySponsor && partyBuyer && withProject && scope.row.buyer')
            template(slot='content')
              | {{ $t('invoices.tooltip.adminApprovalFlow') }}
            ods-button(
              style=' padding-left: 10px; padding-right: 0px;'
              type='neutral',
              @click='handleGoApprovalFlow(scope.row)')
              ods-icon(name='flow', size='16')

    ods-row.b2b-table-centres__pagination()
      ods-col.b2b-table-centres__pagination--left(:span='4')

        //- Paginación Tabla
      ods-col.b2b-table-centres__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='centres.totalCentres')

    //- Empresas Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersCentres from '@/views/administracion/centros/B2bFiltersCentres'
import B2bTableMenuCentres from '@/views/administracion/centros/B2bTableMenuCentres'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-centros'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-centres',
  mixins: [Utils],
  data () {
    return {
      partySponsor: false,
      partyBuyer: false,
      withProject: false,
      projectWithApprovalFlowConfiguration: false, // true si el proyecto tiene la configuración de flujo de aprobación, false en caso contrario
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'centres',
      'queryCentres',
      'isShowNameCentre',
      'isShowCreationDateTimeCentre',
      'isShowCodeCentre',
      'isShowGlnCentre',
      'isShowTownCentre',
      'isShowProvinceCentre',
      'isShowCountryCentre',
      'primaryColor',
      // Permisos
      'canAdminApprovalFlowByLevels',
      'canAdminIndra',
      'canAdminProject'
    ])
  },

  components: {
    B2bFiltersCentres,
    B2bTableMenuCentres,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getCentresByPartyCentres',
      'getPartyService',
      'getProjectPartyService',
      'getServiceDetail',
      'queryCentresState',
      'updateStatusCentre',
      'updatePermanentEstablishmentCentre',
      'getDataConfigurationCode'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      console.log('orderOnServer...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''

        const dataQuery = {
          query: {}
        }
        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }
        if (!prop) {
          prop = 'id'
        }
        if (this.$route.params.projectId) {
          this.queryCentres.projectId = this.$route.params.projectId
        }
        this.queryCentres.partyId = this.$route.params.partyId
        stringSort = prop + ',' + order
        this.queryCentres.sort = stringSort
        await this.queryCentresState(this.queryCentres)
        dataQuery.query = this.queryCentres
        const response = await this.getCentresByPartyCentres(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async updateCentreStatus (row) {
      try {
        const request = {
          partyId: row.id,
          enable: row.enable
        }
        await this.updateStatusCentre(request)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async updateCentrePermanentEstablishment (row) {
      try {
        const request = {
          partyId: row.id,
          permanentEstablishment: row.permanentEstablishment
        }
        await this.updatePermanentEstablishmentCentre(request)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    /* Ir al detalle */
    async handleGoDetail (centre) {
      let projectName
      let partyName

      if (this.$route.params.projectId) {
        const project = await this.getServiceDetail(this.$route.params.projectId)
        const party = await this.getPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        projectName = project.name
        partyName = party.tradeName

        const response = await this.getProjectPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        this.partySponsor = response.sponsor
        sessionStorage.setItem('partyName', party.corporateName)
        sessionStorage.setItem('projectName', project.name)
      } else {
        partyName = sessionStorage.getItem('partyName')
      }

      sessionStorage.setItem('centreCode', centre.centreCode)

      let pageCentreName = 'page-centre'

      if (this.$route.name === 'table-centres-profile') {
        pageCentreName = 'page-centre-profile'
      } else if (!this.$route.params.projectId) {
        pageCentreName = 'page-centre-party'
      }

      router.push({
        name: pageCentreName,
        params: {
          centreId: centre.id,
          centreCode: centre.centreCode,
          projectName: projectName,
          partyName: partyName
        }
      })
    },

    /* Ir a la administración del flujo de aprobación por niveles */
    async handleGoApprovalFlow (centre) {
      let projectName
      let partyName

      if (this.$route.params.projectId) {
        const project = await this.getServiceDetail(this.$route.params.projectId)
        const party = await this.getPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        projectName = project.name
        partyName = party.tradeName

        const response = await this.getProjectPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        this.partySponsor = response.sponsor
        sessionStorage.setItem('partyName', party.corporateName)
        sessionStorage.setItem('projectName', project.name)
        sessionStorage.setItem('centreCode', centre.centreCode)
        sessionStorage.setItem('centreDescription', centre.description)

        const pageCentreName = 'page-approval-flows'
        router.push({
          name: pageCentreName,
          params: {
            centreId: centre.id,
            centreCode: centre.centreCode,
            projectName: projectName,
            partyName: partyName
          }
        })
      }
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    formatterCountry (row, column) {
      return row.country != null ? this.$t('countries.country_' + row.country) : null
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuCentres />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        if (this.$route.params.projectId) {
          this.queryCentres.projectId = this.$route.params.projectId
        }
        this.queryCentres.partyId = this.$route.params.partyId
        this.queryCentres.size = val
        await this.queryCentresState(this.queryCentres)
        dataQuery.query = this.queryCentres
        const response = await this.getCentresByPartyCentres(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        if (this.$route.params.projectId) {
          this.queryCentres.projectId = this.$route.params.projectId
        }
        this.queryCentres.partyId = this.$route.params.partyId
        this.queryCentres.page = val - 1
        await this.queryCentresState(this.queryCentres)
        dataQuery.query = this.queryCentres
        const response = await this.getCentresByPartyCentres(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Consulta de configuraciones del proyecto
    async getProjectConfigurations () {
      if (this.queryCentres.projectId) {
        const configuraciones = await this.getDataConfigurationCode({
          serviceId: this.queryCentres.projectId,
          dataconfigurationCode: 'APPROVAL_FLOW_BY_LEVELS_AND_USERS'
        })
        if (configuraciones && configuraciones.length > 0) {
          if (configuraciones[0]) {
            console.log('configuraciones[0]: ', configuraciones[0])
            this.projectWithApprovalFlowConfiguration = true
          }
        }
      }
      console.log('projectWithApprovalFlowConfiguration: ', this.projectWithApprovalFlowConfiguration)
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = 'global_error'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = {
        query: {}
      }

      if (this.$route.params.projectId) {
        this.queryCentres.projectId = this.$route.params.projectId
      }

      this.queryCentres.partyId = this.$route.params.partyId

      this.options = filters.filters
      dataQuery.query = this.queryCentres
      const response = await this.getCentresByPartyCentres(dataQuery)
      this.totalResults = response.data.totalElements
      this.currentPage = response.data.number + 1
      if (this.queryCentres.projectId && this.queryCentres.partyId) {
        const responseProjectParty = await this.getProjectPartyService({
          serviceId: this.queryCentres.projectId,
          partyId: this.queryCentres.partyId
        })
        this.partySponsor = responseProjectParty.sponsor
        this.partyBuyer = responseProjectParty.buyer
        this.withProject = (this.$route.params.projectId !== undefined && this.$route.params.projectId !== null)
        console.log('this.withProject: ', this.withProject)
      }
      await this.getProjectConfigurations() // Consulta de configuraciones del proyecto
    } catch (error) {
      this.getNotificationErrorMessage(error)
      console.log('getCentres CATCH: ', error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-centres {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
  .selected-text {
    font-weight: bold;
  }
  .noselected-text {
    //color: var(--color-bg-interactive)
    color:blueviolet
  }
}
</style>
